import { resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0433629b")

_pushScopeId("data-v-0433629b")
const _hoisted_1 = { class: "Search__result-container" }
const _hoisted_2 = { class: "Search__result-header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 총 검색 내역 ")
const _hoisted_4 = { class: "Search__result-total-count" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("건 ")
const _hoisted_6 = { class: "Search__result-items" }
const _hoisted_7 = { class: "Search__result-item-section" }
const _hoisted_8 = { class: "Search__result-item-id" }
const _hoisted_9 = { class: "Search__result-item-type" }
const _hoisted_10 = {
  key: 0,
  class: "Search__result-item-comments"
}
const _hoisted_11 = {
  key: 1,
  class: "Search__no-result"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("자전거 번호를 입력하면 발급된 티켓 또는")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("거점을 확인할 수 있습니다.")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("검색 결과가 없습니다.")
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "Search__result-items" }
const _hoisted_18 = { class: "Search__result-item-section" }
const _hoisted_19 = { class: "Search__result-item-id" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "Search__result-item-type" }, "거점", -1)
const _hoisted_21 = { class: "Search__result-item-base-point" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", null, ">", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_AdaptiveWindowLayout = _resolveComponent("AdaptiveWindowLayout")

  return (_openBlock(), _createBlock(_component_AdaptiveWindowLayout, { "bottom-navigation": "" }, {
    default: _withId(() => [
      _createVNode("div", {
        class: "Search",
        onMousemove: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
        onTouchmove: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
        onScroll: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(_component_SearchInput, {
          class: "Search__input-area",
          keyword: _ctx.keyword,
          "onUpdate:keyword": _cache[1] || (_cache[1] = $event => (_ctx.keyword = $event)),
          maxlength: _ctx.maxLength,
          placeholder: "자전거 번호 6자리 입력",
          focus: "",
          onClick: _ctx.searchKeyword,
          onKeyup: _withKeys(_ctx.searchKeyword, ["enter"]),
          onMousemove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          onTouchmove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onScroll: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
        }, null, 8, ["keyword", "maxlength", "onClick", "onKeyup"]),
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.totalCount), 1),
            _hoisted_5
          ]),
          _createVNode("div", _hoisted_6, [
            (_ctx.searchResult.length > 0)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchResult, (item, itemIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `result-item-${itemIndex}`,
                    class: "Search__result-item",
                    onClick: $event => (item.isBringInTicket
                ? _ctx.goBringInView((item.filter & _ctx.BikeFilter.REPAIR) !== 0 ? _ctx.BringInTicketType.REPAIR : _ctx.BringInTicketType.RELOCATION)
                : _ctx.goMainViewTicket(item))
                  }, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, _toDisplayString(item.code), 1),
                      _createVNode("div", _hoisted_9, _toDisplayString(item.type), 1)
                    ]),
                    (item.comments !== '-')
                      ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(item.comments), 1))
                      : _createCommentVNode("", true)
                  ], 8, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createBlock("div", _hoisted_11, [
                  (!_ctx.didSearch)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _hoisted_12,
                        _hoisted_13,
                        _hoisted_14
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _hoisted_15
                      ], 64 /* STABLE_FRAGMENT */))
                ])),
            (_ctx.searchedBasePoint)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", {
                      class: "Search__result-item",
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.goBringInView((_ctx.searchResult.filter(d => d.isBringInTicket)[0].filter & _ctx.BikeFilter.REPAIR) !== 0 ? _ctx.BringInTicketType.REPAIR : _ctx.BringInTicketType.RELOCATION)))
                    }, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("div", _hoisted_19, _toDisplayString(_ctx.searchResult[0].code), 1),
                        _hoisted_20
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", null, _toDisplayString(_ctx.store.state[_ctx.MutationName.REGION_MAP][_ctx.searchedBasePoint.region_id]?.name || '-'), 1),
                        _hoisted_22,
                        _createVNode("div", null, _toDisplayString(_ctx.searchedBasePoint.name), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
})